import React from 'react'
import { useTranslation } from 'react-i18next'
import DatePicker from 'react-datepicker'

import HintIcon from 'pages/parts/HintIcon'
import { formatDate, parseLocalDateInput } from 'helpers/helpers'

/**
 * Период действия скидки «с — по» (обе даты включительно). Пустое поле — без границы.
 * Вне периода скидка не применяется и не показывается ни на кассе, ни на сайте, в боте и приложении.
 */
function ValidPeriod({ data, setData }) {
	const { t } = useTranslation()
	// «по» раньше «с» — сервер такое не сохранит, подсвечиваем сразу
	const invalid = !!(data.valid_from && data.valid_to && String(data.valid_to) < String(data.valid_from))

	return (
		<div className="d-flex gap-2">
			<div className="form-group w-50">
				<label>
					{t('discount_valid_from', 'Действует с')}
					<HintIcon text={t('discount_valid_period_hint', 'Скидка сама включится в первый день и выключится после последнего. Пусто — без ограничения.')} />
				</label>
				<div className="calendar-input">
					<DatePicker
						className="form-control"
						dateFormat="dd.MM.yyyy"
						isClearable
						popperProps={{ 'strategy': 'fixed' }}
						selected={parseLocalDateInput(data.valid_from)}
						onChange={(date) => setData({ ...data, 'valid_from': date ? formatDate(date, 'yyyy-MM-dd') : null })} />
					<i className="uil uil-calendar-alt"></i>
				</div>
			</div>
			<div className="form-group w-50">
				<label>{t('discount_valid_to', 'по')}</label>
				<div className="calendar-input">
					<DatePicker
						className={`form-control ${invalid ? 'is-invalid' : ''}`}
						dateFormat="dd.MM.yyyy"
						isClearable
						popperProps={{ 'strategy': 'fixed' }}
						minDate={parseLocalDateInput(data.valid_from)}
						selected={parseLocalDateInput(data.valid_to)}
						onChange={(date) => setData({ ...data, 'valid_to': date ? formatDate(date, 'yyyy-MM-dd') : null })} />
					<i className="uil uil-calendar-alt"></i>
				</div>
				{invalid &&
					<div className="text-danger small mt-1">{t('discount_valid_period_invalid', 'Дата окончания раньше даты начала')}</div>
				}
			</div>
		</div>
	)
}

/** Подпись периода для списка: «01.11 – 10.11», «с 01.11», «по 10.11» или пусто. */
export function formatValidPeriod(item) {
	const from = item?.valid_from ? formatDate(parseLocalDateInput(item.valid_from), 'dd.MM.yy') : null
	const to = item?.valid_to ? formatDate(parseLocalDateInput(item.valid_to), 'dd.MM.yy') : null
	if (from && to) return `${from} – ${to}`
	if (from) return `с ${from}`
	if (to) return `по ${to}`
	return ''
}

/** Сегодня вне периода: 'future' — ещё не началась, 'expired' — закончилась, null — действует. */
export function validPeriodState(item) {
	const d = new Date()
	const today = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
	if (item?.valid_from && today < String(item.valid_from).slice(0, 10)) return 'future'
	if (item?.valid_to && today > String(item.valid_to).slice(0, 10)) return 'expired'
	return null
}

export default ValidPeriod
